<template>
  <main>
    <fade-in-top-title class="title-interval">
        <h3>Instagram 働く ＆<br>リフレッシュキャンペーン</h3>
        <span>Html/Css/Js</span>
    </fade-in-top-title>
    <div class="container container-web">
      <work-contents-top>
        <img src="@/assets/images/workContents02_pc.png" alt="">
      </work-contents-top>
      <work-contents-text-team
      webSiteText="「Instagram 働く＆リフレッシュキャンペーン」" />
      <div class="work-contents-wrapper">
        <work-contents-block title="スライダー１">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents02_pc_02.png" alt="">
            <img class="sp" src="@/assets/images/workContents02_sp_02.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="スライダー２">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents02_pc_03.png" alt="">
            <img class="sp" src="@/assets/images/workContents02_sp_03.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="「スライダー１」と「スライダー２」のスライダー機能の挙動はこちら">
          <div class="gif" @click="gifClick01">
            <img :src="gif01.src" alt="" :id="1">
            <play-icon v-show="show01"></play-icon>
          </div>
        </work-contents-block>
      </div>
    </div>
    <router-link to="/work/workContents01">
      <work-slide-left></work-slide-left>
    </router-link>
    <router-link to="/work/workContents03">
      <work-slide-right></work-slide-right>
    </router-link>
  </main>
</template>



<script>
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import WorkContentsTextTeam from '../components/WorkContentsTextTeam.vue';
import WorkContentsTop from '../components/WorkContentsTop.vue';
import WorkContentsBlock from '../components/WorkContentsBlock.vue';
import WorkSlideLeft from '../components/WorkSlideLeft.vue';
import WorkSlideRight from '../components/WorkSlideRight.vue';
import PlayIcon from '../components/PlayIcon.vue';

export default {
  data() {
    return {
      gif01: {
        src: require('@/assets/gifs/workContents02-01_play.gif')
      },
      show01: true,
    }
  },
  components: {
    FadeInTopTitle,
    WorkContentsTextTeam,
    WorkContentsTop,
    WorkContentsBlock,
    WorkSlideLeft,
    WorkSlideRight,
    PlayIcon
  },
  methods: {
    gifClick01() {
      this.show01 = !this.show01;
      if(this.show01) {
        this.gif01.src = require('@/assets/gifs/workContents02-01_play.gif');
      } else {
      this.gif01.src = require('@/assets/gifs/workContents02-01.gif');
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>